import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqItems = [
  { q: "faq.q1", a: "faq.a1" },
  { q: "faq.q2", a: "faq.a2" },
  { q: "faq.q3", a: "faq.a3" },
  { q: "faq.q4", a: "faq.a4" },
  { q: "faq.q5", a: "faq.a5" },
];

function buildFaqJsonLd(t: (key: string) => string): string {
  const mainEntity = faqItems.map((item) => ({
    "@type": "Question" as const,
    name: t(item.q),
    acceptedAnswer: {
      "@type": "Answer" as const,
      text: t(item.a),
    },
  }));
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  });
}

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="relative py-16 md:py-24 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: buildFaqJsonLd(t) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t("faq.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {t(item.q)}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIdx === idx ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-5 md:px-6 text-sm text-foreground-600 leading-relaxed">
                  {t(item.a)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}